import React from 'react';
import { Row } from 'react-bootstrap';
import ExitoCard from './ExitoCard';
export interface ExitoOption {
    path: string;
    variant: 'primary' | 'secondary' | 'success';
    description: string;
    isLast?: boolean;
}

function Exito({title, options} : {title: string; options: ExitoOption[]}) {
    return (
        <Row className="justify-content-center">
            <div className="col-xs-12 col-md-10 col-lg-8 col-xxl-5">
                <ExitoCard title={title} options={options}/>
            </div>
        </Row>
    );
}
export default Exito;